import { useNavigate } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    // This works exactly like the browser's back button
    navigate(-1);
  };

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="error-code">404</div>
        <h1 className="error-title">Page Not Found</h1>
        <p className="error-message">
          Sorry, the page you are looking for doesn't exist or has been moved.
        </p>
        <div className="action-buttons">
          <button 
            onClick={handleGoBack}
            className="btn btn-back"
          >
            ← Go Back
          </button>
          <button 
            onClick={() => navigate('/')}
            className="btn btn-home"
          >
            Go Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;